import React from "react";
import { formatEUR0 } from "@/lib/format";
import { CLASS_COLOR, CLASS_LABEL, GREEN, RED, Sparkline, TEAL, plColor, pctStr } from "./shared";

// Riepilogo portafoglio: hero valore di mercato + andamento storico + allocazione.
export const PortfolioOverview = ({ data, history }) => (
  <>
    {/* hero */}
    <div className="rounded-[12px] border bg-[#0D0D14] p-4" style={{ borderColor: `${TEAL}33`, boxShadow: `0 0 0 1px ${TEAL}14` }}>
      <p className="caps-tag" style={{ color: TEAL, opacity: 0.85 }}>Valore di mercato</p>
      <p className="mono mt-2 text-[38px] font-light leading-none tracking-[-1.5px] tabular" style={{ color: TEAL }} data-testid="invest-total">
        {formatEUR0(data.total_value)}
      </p>
      <div className="mono mt-3 flex flex-wrap items-center gap-x-3 gap-y-1 text-[12px]">
        <span data-testid="invest-pl" style={{ color: plColor(data.total_pl) }}>
          P/L {data.total_pl >= 0 ? "+" : "−"}{formatEUR0(Math.abs(data.total_pl))} ({pctStr(data.total_pl_pct)})
        </span>
        <span className="text-white/20">·</span>
        <span className="text-white/45" data-testid="invest-change24h">
          24h <span style={{ color: plColor(data.change_24h_pct) }}>{pctStr(data.change_24h_pct)}</span>
        </span>
      </div>
    </div>

    {/* andamento patrimonio (storico snapshot) */}
    {history && history.length >= 2 ? (
      (() => {
        const series = history.map((s) => s.net_worth);
        const first = series[0] || 0;
        const last = series[series.length - 1] || 0;
        const chg = first ? ((last - first) / first) * 100 : 0;
        const col = chg >= 0 ? GREEN : RED;
        return (
          <div className="mt-4 rounded-[12px] border border-white/[0.06] bg-[#0D0D14] p-4" data-testid="invest-performance">
            <div className="flex items-center justify-between">
              <p className="caps-tag text-white/45">Andamento patrimonio · {history.length}g</p>
              <span className="mono text-[11px]" style={{ color: col }}>{pctStr(chg)}</span>
            </div>
            <div className="mt-3"><Sparkline values={series} color={col} /></div>
            <div className="mono mt-1.5 flex justify-between text-[10px] tracking-[0.05em] text-white/30">
              <span>{formatEUR0(first)}</span>
              <span>{formatEUR0(last)}</span>
            </div>
          </div>
        );
      })()
    ) : (
      <div className="mt-4 rounded-[12px] border border-dashed border-white/[0.1] bg-[#0D0D14] p-4 text-center" data-testid="invest-performance-empty">
        <p className="mono text-[12px] text-white/50">Andamento in costruzione</p>
        <p className="mt-1 text-[11px] font-light leading-snug text-white/35">
          Salviamo uno snapshot del tuo patrimonio ad ogni sync (ogni 6h). Il grafico appare con almeno 2 rilevazioni.
        </p>
      </div>
    )}

    {/* allocazione */}
    {data.allocation?.length > 0 && (
      <div className="mt-4" data-testid="investments-allocation">
        <p className="caps-tag mb-2 text-white/45">Allocazione</p>
        <div className="flex h-2.5 overflow-hidden rounded-full bg-white/[0.05]">
          {data.allocation.map((a) => (
            <div key={a.asset_class} style={{ width: `${a.pct}%`, backgroundColor: CLASS_COLOR[a.asset_class] || "#888" }} />
          ))}
        </div>
        <div className="mt-2 flex flex-wrap gap-x-4 gap-y-1">
          {data.allocation.map((a) => (
            <span key={a.asset_class} className="mono inline-flex items-center gap-1.5 text-[11px] text-white/55">
              <span className="h-2 w-2 rounded-[2px]" style={{ backgroundColor: CLASS_COLOR[a.asset_class] || "#888" }} />
              {CLASS_LABEL[a.asset_class] || a.asset_class} {a.pct}%
            </span>
          ))}
        </div>
      </div>
    )}
  </>
);
